import api from './axios';

// Tüm planları getir
export const getAllPlans = async () => {
    try {
        const response = await api.get("api/PremiumPlan/plans");
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Planlar alınamadı!" };
    }
};

// Yeni plan ekle
export const addPlan = async (data) => {
    try {
        const response = await api.post("api/PremiumPlan/plan-add", data);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Plan eklenemedi!" };
    }
};

// Plan güncelle
export const updatePlan = async (id, data) => {
    try {
        const response = await api.put(`api/PremiumPlan/plan-update/${id}`, data);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Plan güncellenemedi!" };
    }
};

// Plan durumu değiştir (Aktif/Pasif)
export const changePlanStatus = async (id) => {
    try {
        const response = await api.patch(`api/PremiumPlan/plan-status-change/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Durum değiştirilemedi!" };
    }
};

// Plan sil
export const deletePlan = async (id) => {
    try {
        const response = await api.delete(`api/PremiumPlan/plan-delete/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Plan silinemedi!" };
    }
};
